var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0.498291C3.13445 0.498291 0 3.63332 0 7.50004C0 11.3668 3.13445 14.5018 7 14.5018C10.8661 14.5018 14 11.3668 14 7.50004C14 3.63332 10.8661 0.498291 7 0.498291ZM9.57431 10.2476L9.37009 10.4519C9.2003 10.6217 8.91381 10.6298 8.73527 10.4688L6.09794 8.16112C5.91823 8.00067 5.78228 7.67217 5.79395 7.43178L6.03843 3.26923C6.05126 3.02826 6.2584 2.83221 6.49937 2.83221H6.78703C7.02801 2.83221 7.23456 3.02826 7.24623 3.26865L7.44636 6.73102C7.45861 6.97199 7.59923 7.3145 7.75852 7.49479L9.59298 9.61165C9.75227 9.79195 9.74469 10.0779 9.57431 10.2476Z",
    fill: "#575656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.1b8c81c581093b3e0114f8581b0d2ab4.svg";
export { ForwardRef as ReactComponent };